import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { MAP_TILE_PADDING } from 'constants/search'
import { Position } from 'components/Search/type'
import SearchResultsMapOfferView from 'components/Search/SearchResultsMap/SearchResultsMapOfferView'

const Container = styled.div<{
  xOffset: number;
  yOffset: number;
}>`
  position: absolute;
  z-index: 5;
  padding: ${rem(MAP_TILE_PADDING)};
  &.position-left {
    transform: translate(
      calc(-100% - ${({ xOffset }) => xOffset}px),
      calc(-50% + ${({ yOffset }) => yOffset}px)
    );
  }
  &.position-right {
    transform: translate(
      calc(0% + ${({ xOffset }) => xOffset}px),
      calc(-50% + ${({ yOffset }) => yOffset}px)
    );
  }
  &.position-up {
    transform: translate(
      calc(-50% + ${({ xOffset }) => xOffset}px),
      calc(-100% - ${({ yOffset }) => yOffset}px)
    );
  }
  &.position-down {
    transform: translate(calc(-50% + ${({ xOffset }) => xOffset}px), 0%);
  }
  &.position-middle {
    transform: translate(
      calc(-50% + ${({ xOffset }) => xOffset}px),
      calc(-50% + ${({ yOffset }) => yOffset}px)
    );
  }
`

interface Props {
  tilePosition?: Position | undefined;
  tileOffset?: { xOffset: number; yOffset: number };
  id: string;
  offerIds: Array<string>;
  filters: App.OfferListFilters;
  onProductClick?: (
    offer:
      | App.Offer
      | App.OfferSummary
      | App.BedbankOffer
      | App.BedbankOfferSummary,
    position: number
  ) => void;
  onDeselectOffers?: () => void;
}

function PositionedMapTile(props: Props) {
  const {
    tilePosition,
    tileOffset,
    id,
    filters,
    onProductClick,
    onDeselectOffers,
    offerIds,
  } = props
  return (
    <Container
      className={
        tilePosition !== undefined ? `position-${tilePosition}` : ''
      }
      xOffset={tileOffset?.xOffset ?? 0}
      yOffset={tileOffset?.yOffset ?? 0}
    >
      <SearchResultsMapOfferView
        key={id}
        offerIds={offerIds}
        filters={filters}
        onProductClick={onProductClick}
        onDeselectOffers={onDeselectOffers}
      />
    </Container>
  )
}

export default PositionedMapTile
